module.exports = __webpack_public_path__ + "static/media/equirectangular-final.c449cf5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/equirectangular-final.jpg
// module id = 564
// module chunks = 0